import { formatDate, formatDateRange } from '@/utils/dateTimeUtils';

export default function formatEventDate(data) {
  if (!data) {
    return '';
  }

  return data.specificDate === 'Yes' ?
    formatDate(data.date) :
    formatDateRange(data.startDate, data.endDate);
}
